$(".close-cookies-alert").click(function(){
    $.ajax({
        url: acceptCookiesUrl,
        success: function() {
            $('body.cookies-alert-visible').removeClass('cookies-alert-visible');
        }
    });
});